import * as React from "react";
import { ReactNode } from "react";
import HeaderWithToggle from "./HeaderWithToggle";
import SavePanel from "./SavePanel";
import SettingsPanel from "./SettingsPanel";

interface SettingsFormProps {
  title: string;
  inactiveSubtitle?: string;
  active?: boolean;
  hasChanges: boolean;
  isValid?: boolean;
  onActivationChange?: (boolean) => void;
  onSave: () => Promise<any>;
  onCancel?: () => void;
  children: ReactNode;
  actionsOnLeftSide?: Boolean;
  id?: string;
}

// sjahan 10/06/20: Must be unified with the Form component and handle global validation and wrap onCancel behaviour.
// sjahan 31/05/21: Deprecated, please do not use it any longer and prefer using a form with proper CSS decoration.
export default function SettingsForm(props: SettingsFormProps) {
  const { title, inactiveSubtitle, active, onActivationChange, onSave, onCancel } = props;
  return (
    <SettingsPanel id={props.id}>
      <HeaderWithToggle title={title} active={active} onChange={onActivationChange} />
      {active === false && inactiveSubtitle ? (
        <div className="setting-description">{inactiveSubtitle}</div>
      ) : (
        <>
          {props.children}
          <SavePanel
            onSave={onSave}
            onCancel={onCancel}
            disabled={!props.hasChanges}
            isValid={props.isValid}
            actionsOnLeftSide={props.actionsOnLeftSide}
            buttonId={props.id && props.id + "-save-button"}
          />
        </>
      )}
    </SettingsPanel>
  );
}
